import { type PropsWithChildren, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { type DefaultTheme, ThemeProvider } from 'styled-components';
import { selectThemeMode } from '../store/plans';
import { darkThemeColors } from './darkTheme';

/** Extends the project theme from `GlobalThemeProvider` with the current theme mode */
export const AppThemeProvider = ({ children }: PropsWithChildren) => {
  const mode = useSelector(selectThemeMode);

  const theme = useCallback(
    (outerTheme?: DefaultTheme): DefaultTheme => {
      const baseTheme = outerTheme ?? ({ colors: {} } as DefaultTheme);

      if (mode !== 'dark') {
        return { ...baseTheme, mode };
      }

      return { ...baseTheme, mode, colors: { ...baseTheme.colors, ...darkThemeColors } };
    },
    [mode],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
